import React, { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'dc-admin-dev-mode';

type AdminDevModeContextValue = {
  devMode: boolean;
  setDevMode: (value: boolean) => void;
  toggleDevMode: () => void;
};

const AdminDevModeContext = createContext<AdminDevModeContextValue>({
  devMode: false,
  setDevMode: () => {},
  toggleDevMode: () => {},
});

export function AdminDevModeProvider({ children }: { children: React.ReactNode }) {
  const [devMode, setDevModeState] = useState(false);

  useEffect(() => {
    try {
      setDevModeState(localStorage.getItem(STORAGE_KEY) === '1');
    } catch {
      /* ignore */
    }
  }, []);

  const setDevMode = (value: boolean) => {
    setDevModeState(value);
    try {
      localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    } catch {
      /* ignore */
    }
  };

  const toggleDevMode = () => setDevMode(!devMode);

  return (
    <AdminDevModeContext.Provider value={{ devMode, setDevMode, toggleDevMode }}>
      {children}
    </AdminDevModeContext.Provider>
  );
}

export function useAdminDevMode() {
  return useContext(AdminDevModeContext);
}
